module.exports = __webpack_public_path__ + "media/assets/icons/cover-background-6ed5e5f6f5190b2f4f21efdcd5814cf8.png";